<template>
    <div class="explanation-container">
        <div>
            <h3 class="text-h5 text-left mb-3">Written Consent Has Been Obtained!</h3>

            <div class="explanation-points">
                <div
                    class="explanation-point"
                    v-for="(point, idx) in explanation_points"
                    :key="idx"
                >
                    <v-icon
                        color="primary"
                        size="28"
                        class="point-icon"
                        aria-hidden="true"
                    >
                        mdi-chevron-right
                    </v-icon>
                    <p class="point-text">{{ point }}</p>
                </div>
            </div>

            <template v-if="!is_change_request">
                <div class="primary-note mt-6">
                    <v-icon
                        color="info"
                        size="20"
                        aria-hidden="true"
                        left
                    >
                        mdi-information
                    </v-icon>
                    <div>
                        <p class="text-body-2 mb-0">
                            <strong class="d-inline-block mb-1">
                                What if {{ order_data.customer_nickname }} had clicked
                                "Request Changes" on the previous screen?
                            </strong>
                        </p>
                        <span class="text-body-2">
                            Continue to the next step to see how written consent can be gathered in that scenario
                        </span>
                    </div>
                </div>
            </template>
        </div>

        <v-btn
            v-if="show_restart"
            color="primary"
            @click="resetDemo"
        >
            <v-icon
                size="18"
                aria-hidden="true"
                left
            >
                mdi-restart
            </v-icon>
            Restart Demo
        </v-btn>
    </div>
</template>

<script>
export default {
    props: {
        is_change_request: {
            type: Boolean,
            default: false
        },

        order_data: {
            type: Object,
            required: true
        },

        submission_data: {
            type: Object,
            required: true
        },

        show_restart: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        explanation_points() {
            const nickname = this.order_data?.customer_nickname || 'The customer';
            if (this.is_change_request) {
                return [
                    `Now that ${nickname} has submitted the form, you will receive a webchat request in RedChirp that your team can respond to and assist in addressing her concerns`,
                    `She provided written consent to receive future marketing messages via text. This consent status, along with the timestamp and IP address, is all recorded for audit purposes`,
                    `You can now leverage this consent within RedChirp to manage this relationship going forward`
                ];
            }

            return [
                `${nickname} has confirmed her order details and now has increased confidence in her order being delivered seamlessly`,
                `Along the way, she provided written consent to receive future marketing messages via text. This consent status, along with the timestamp and IP address, is all recorded for audit purposes`,
                `You can now leverage this consent within RedChirp to manage this relationship going forward`
            ];
        }
    },

    methods: {
        resetDemo() {
            this.$emit('reset');
        }
    }
}
</script>

<style lang="scss" scoped>
.explanation-container {
    display: flex;
    flex-direction: column;
    text-align: left;
    gap: 2rem;
    align-items: center;
    padding: 2rem;

    @media (max-width: 900px) {
        padding: .5rem 0;
    }
}
</style>
